import { isValidDate } from '@cian/utils';

/**
 * Приводит дату к формату DD.MM.YYYY
 */
export const formatDateToDDMMYYYY = (date: Date) =>
  isValidDate(date)
    ? date.toLocaleDateString('ru-RU', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    : '';
